"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STEP_DESCRIPTIONS = void 0;
// Order matters! This is the order in which the steps occur.
exports.STEP_DESCRIPTIONS = ['Generate loan tapes'];
//# sourceMappingURL=GenerateLoanTapes.js.map